import gameConfig from "../../../../../../engines/configs/gameConfig";
import { FileKind } from "../../../../../define/FileKind";

/**
 * 刮刮乐
 */
export namespace LotteryKind {

    export enum GeneralValue {
        /** 单点圆大小 */
        SINGLE_TOUCH_CIRCLE = 30,
        MULTI_TOUCH_LINE = 50,
        /**  */
        EVERY_CIRCLE_ADJUST = 6,
    }

    export class LotteryItemInfo {
        idx: number = 0;
        icon: string = null;
        name: string = null;
        price: number = 0;
        /** 每天购买限制次数 */
        limitCount: number = 0;
        /** 是否是旧的方式 */
        bOld?: boolean = false;
        /** 窗口路径 */
        dialogPath?: FileKind.PrefabFileInfo = null;
    }

    export const LotteryList: LotteryItemInfo[] = [
        {
            idx: 0
            , icon: 'spr_old'
            , name: '古老的刮刮乐，我也不知道叫啥'
            , price: 20
            , limitCount: gameConfig.NEW_GGL_CURR_LIMIT2
            , bOld: true
            , dialogPath: FileKind.PrefabFilePath.shopNewGGL1Prefab
        }
        , {
            idx: 3
            , icon: 'spr_cheng_yi'
            , name: '橙意满满'
            , price: 1000
            , limitCount: gameConfig.LOTTERY_CHENG_YI_MANMAN_LIMIT
            , dialogPath: FileKind.PrefabFilePath.ChengYiManManLayer
        } 
        , {
            idx: 2
            , icon: 'spr_ming_tang'
            , name: '名堂刮刮乐'
            , price: 20000
            , limitCount: gameConfig.LOTTERY_MING_TANG_LIMIT
            , dialogPath: FileKind.PrefabFilePath.MingTangLayer
        } 
        , {
            idx: 5
            , icon: 'spr_zhong_zhong'
            , name: '快乐中中中'
            , price: 20000
            , limitCount: gameConfig.LOTTERY_HAPPY_WIN_LIMIT
            , dialogPath: FileKind.PrefabFilePath.HappyWinLayer
        } 
        , {
            idx: 1
            , icon: 'spr_que_shen'
            , name: '雀神刮刮乐'
            , price: 50000
            , limitCount: gameConfig.LOTTERY_QUE_SHEN_LIMIT
            , dialogPath: FileKind.PrefabFilePath.MahjongLayer
        }
        , {
            idx: 4
            , icon: 'spr_jin_hua'
            , name: '金花大乱斗'
            , price: 500000
            , limitCount: gameConfig.LOTTERY_JIN_HUA_LIMIT
            , dialogPath: FileKind.PrefabFilePath.GoldFlowerLayer
        } 

    ];
}

